import { products } from "data/products";

export const content = {
  en: {
    //Heading Home and navigation
    heading1: "The Next",
    heading2: "Generation",
    heading3: "Business Card.",
    subHeading: "Tap and Share Your Contact Info.",
    getStartedButton: "Get started",
    commingSoon: "Comming Soon!",
    modalHeading: "Receive Notice When Techhype Launch",
    modalInput: "Email",
    modalButton: "Get Notice",
    modalInputError: "Please enter a valid email",
    ModalConfirmation:
      "Thank you! We will send you an email when Techhype is launched.",
    submitError: "An error occured, Please try again later",
    error: "Error",
    menuItem1: "Get Started",
    menuItem2: "How it Works",
    menuItem3: "Reviews",
    menuItem4: "Contact Us",
    loginTooltip: "My Account",
    cartToolTip: "Cart",
    //How it works section
    howPreHeading: "3 easy steps",
    howHeading: "How It Works",
    purchaseHeading: "Purchase your Card",
    purchaseText:
      "After placing your order, you will receive instructions on how to provide us with your logo or design for the card.",
    purchaseButton: "View Products",
    createProfileHeading: "Create Your Profile",
    createProfileText:
      "Here you can add, edit and enable what you would like to share with your contactless business card.",
    createProfileButton: "Sign Up",
    goHeading: "Tap, Share & Go!",
    goText:
      "It's that simple! Tap your card on any smartphone and Share who you are and what you do with one quick tap.",
    //Benefits section
    benefitsPreHeading: "benefits",
    benefitsHeading: "One Card Forever",
    benefitsParagraph:
      "Simplify networking and leave a lasting impression with a digital NFC business card from Techhype. Instantly share your contact details with a tap, eliminating the need for outdated paper cards.",
    benefitsIcon1: "Professional",
    benefitsIcon2: "Easy",
    benefitsIcon3: "Sustainable",
    //Reviews section
    reviewsHeading: "Reviews",
    reviewsSubHeading: "Hear what others say about Techhype",
    verifiedCustomer: "Verified Customer",
    moreReviewsButton: "More Reviews",
    //Clients section
    clientsPreHeading: "Trusted Clients",
    clientsHeading: "Companies Using Techhype",
    //Footer
    footerHeading: "Links",
    footerLink1: "Get Started",
    footerLink2: "How It Works",
    footerLink3: "Reviews",
    footerLink4: "Contact Us",
    footerLink5: "Login",
    footerInfo:
      "Contactless Business card using NFC technology to simplify networking and sharing contact details.",
    copyRights: "Copyright ©Techhype 2023. All rights reserved.",
    footerTermsHeading: "Terms and Privacy",
    footerTerms: "Terms and Conditions",
    footerPrivacy: "Privacy Policy",
    footerFaq: "FAQ",
    //Contact Page
    contactHeading: "Contact Us",
    contactSubHeading:
      "Do you have a question or need help with an order? Just fill out the form fields below.",
    selectLabel: "I need help with..",
    selectOption1: "General Inquiry",
    selectOption2: "My Current Order",
    selectOption3: "Technical Support",
    nameLabel: "Name",
    emailLabel: "Email",
    phoneLabel: "Phone",
    phonePlaceholder: "Optional",
    messageLabel: "Message",
    messagePlaceholder: "Write your message here...",
    contactButton: "Send",
    //Shop Page
    shopHeading: "Choose Your Card",
    productButton: "Select",
    //Login Page
    loginHeading: "Login",
    userEmail: "Email",
    password: "Password",
    loginButton: "Login",
    forgotPassword: "Forgot Password?",
    loginOr: "Or",
    loginFacebook: "Login with Facebook",
    loginGoogle: "Login With Google",
    dontHaveAnAccount: "Don't have an account?",
    registerHeading: "Register",
    registerName: "Name",
    registerButton: "Register",
    alreadyHaveAnAccount: "Already have an account?",
    haveAccountLogin: "Log in",
    signUp: "Sign up",
    forgotPasswordHeader: "Forgot Password",
    resetPasswordButton: "Reset Password",
    backToLoginLink: "Back to login",
    //Reset password Page
    resetTitle: "New Password",
    resetButton: "Update",
    //Cart Page
    cartHeading: "Cart",
    cartEmpty: "You have no items in the shopping cart",
    cartTotal: "Total",
    cartRemove: "Remove",
    shipping: "Shipping",
    checkout: "Checkout",
    shippingInfo: "Free shipping for orders above 2000 Kr",
    cartTip: "Create your profile and design your card after Checkout.",
    goToShopButton: "Buy card",
    //BreadCrumbs
    home: "Home",
    shop: "Get Started",
    //Products Details
    quantity: "Quantity",
    addToCart: "Add To Cart",
    detailsAccordionHeader: "Details",
    details1:
      "Techhype is pulling the humble business card straight into the 21st century, with fully integrated NFC technology.",
    details2:
      "Our business cards are the perfect way to communicate with customers and business connections alike - giving you complete marketing and networking versatility. Now you are no longer limited to simply sharing your contact details. With custom actions, you can instantly transfer information or cause any action on a smartphone.",
    details3:
      "Upload a logo or brand image to be printed directly onto your card.",
    warrantyAccordionHeader: "Warranty",
    warrantyText:
      "1 year. Applies only if the card is defect. Lost or stolen card is not covered by the warranty",
    FaqAccordionHeader: "FAQ's",
    faqQuestion1: "Can I have several profiles in one card?",
    faqAnswer1:
      "Yes, You can have up to 3 profiles on a card. Only one profile can be active at once. You can manage your profiles and their active state from your account.",
    faqQuestion2: "Does the card work for all SmartPhones?",
    faqAnswer2:
      "Techhype Digital Business card work for all Smartphones which have NFC. Most Smartphones of newer age does have NFC.",
    faqQuestion3: "What should I do if I lose my card?",
    faqAnswer3:
      "If you lose your card you can simply go to your account and block it to make sure it won't be abused.",
    //Added to cart modal
    addedToCart: "Added to Cart!",
    cartTotal: "Total",
    closeModalButton: "Close",
    GoToCartModalButton: "Go to Cart",
    outOfStock: "Out of Stock",
    //Checkout
    checkoutHeading: "Checkout",
    hideOrderSummary: "Hide Order Summary",
    showOrderSummary: "Show Order Summary",
    contactInfoShort: "Contact",
    contactInfoLong: "Contact Information",
    checkoutHaveAccount: "Have an account?",
    checkoutLogin: "Log in",
    checkoutEmail: "Email",
    checkoutEmailPlaceholder: "You@email.com",
    checkoutPhonePlaceholder: "Optional",
    shippingAddress: "Shipping Address",
    checkoutName: "Name",
    checkoutCompany: "Company",
    checkoutStreet: "Street address",
    checkoutPostal: "Postal Code",
    checkoutCity: "City",
    checkoutReturnToCart: "Return to cart",
    paymentButtonShort: "Payment",
    paymentButtonLong: "Continue to payment",
    discountCode: "Discount Code",
    DiscountButton: "Apply",
    checkoutShipping: "Shipping",
    checkoutTotal: "Total",
    checkoutOrderSummary: "Order Summary",
    //Country Input
    countryInputLabel: "Country",
    countryInputPlaceholder: "Select Country",
    //Phone Input
    phoneInputLabel: "Phone Number",
    phoneInputError: "Phone number is to long",
    //Payment
    paymentHeading: "Payment",
    paymentReturnToCheckout: "Return to Checkout",
    paymentButton: "Pay Now",
    changeInfo: "Change",
    paymentContact: "Contact",
    paymentShipTo: "Ship to",
    billingAddressHeader: "Billing Address",
    billingAddressSubheader:
      "Select the address that matches your card or payment method.",
    billingOption1: "Same as shipping address",
    billingOption2: "Use a different address",
    shippingMethodHeader: "Shipping Method",
    shippingOption1: "Standard (1-5 Business Days)",
    shippingOption2: "Home Delivery (1-3 Business days)",
    paymentHeader: "Payment",
    paymentSubheader: "All transactions are secure and encrypted.",
    paymentOption1: "Credit Card",
    paymentOption2: "Vipps",
    paymentCardNumberLabel: "Card Number",
    paymentNameOnCardLabel: "Name on Card",
    paymentExpiryDateLabelLong: "Expiration date (MM / YY)",
    paymentExpiryDateLabelShort: "Exp date (MM / YY)",
    paymentCVCCodeLabel: "CVC",
    //Confirmation Page
    confirmationPageTitle: "Your order is confirmed!",
    orderNumber: "Order #",
    orderDetails: "Order Details",
    contactInformationHeader: "Contact Information",
    paymentMethodHeader: "Payment Method",
    paymentMethodCard: "Card ending with",
    shippingAddressHeader: "Shipping Address",
    billingAddressHeader: "Billing Address",
    shippingMethodHeader: "Shipping Method",
    confirmationByEmail:
      "You will receive a confirmation email with your order shortly.",
    needHelp: "Need help?",
    confirmationPageContactUs: "Contact Us",
    confirmationCreateProfileButton: "Create Your Profile",
    confirmationTooltip:
      "Create your profile now and start designing your business card!",
  },
  no: {
    //Heading Home and navigation
    heading1: "Den Neste",
    heading2: "Generasjonen",
    heading3: "Visittkort.",
    subHeading: "Tap og Del Din Kontaktinfo.",
    getStartedButton: "Kom i gang",
    commingSoon: "Kommer Snart!",
    modalHeading: "Motta Varsel Når Techhype Lanseres",
    modalInput: "E-post",
    modalButton: "Få Varsel",
    modalInputError: "Vennligst fyll inn en gyldig E-post",
    ModalConfirmation: "Takk! Vi sender deg en E-post når Techhype er lansert.",
    submitError: "En feil oppstod, vennligst prøv igjen senere",
    error: "Feilmelding",
    menuItem1: "Kom i gang",
    menuItem2: "Hvordan det Fungerer",
    menuItem3: "Anmeldelser",
    menuItem4: "Kontakt Oss",
    loginTooltip: "Min Konto",
    cartToolTip: "Handlekurv",
    //How it works section
    howPreHeading: "3 enkle steg",
    howHeading: "Hvordan Det Fungerer",
    purchaseHeading: "Kjøp ditt kort",
    purchaseText:
      "Etter at du har plassert bestillingen din, vil du motta instruksjoner om hvordan du gir oss logoen din eller designet for kortet.",
    purchaseButton: "Se Produkter",
    createProfileHeading: "Opprett Bruker",
    createProfileText:
      "Her kan du legge til, redigere og aktivere det du ønsker å dele med ditt kontaktløse visittkort.",
    createProfileButton: "Registrer deg",
    goHeading: "Tap, Del og Gå!",
    goText:
      "Det er så enkelt! Tap kortet på hvilken som helst smarttelefon og del hvem du er og hva du gjør med bare ett raskt tap.",
    //Benefits section
    benefitsPreHeading: "Fordeler",
    benefitsHeading: "Ett kort For Evigheten",
    benefitsParagraph:
      "Forenkle nettverksbyggingen og etterlat et varig inntrykk med et digitalt NFC-visittkort fra Techhype. Del umiddelbart kontaktinformasjonen din med en enkel berøring, og eliminer behovet for utdaterte papirkort.",
    benefitsIcon1: "Proft",
    benefitsIcon2: "Enkelt",
    benefitsIcon3: "Bærekraftig",
    //Reviews section
    reviewsHeading: "Anmeldelser",
    reviewsSubHeading: "Hør hva andre synes om Techhype",
    verifiedCustomer: "Verifisert Kunde",
    moreReviewsButton: "vis mer",
    //Clients section
    clientsPreHeading: "Pålitelige kunder",
    clientsHeading: "Bedrifter som bruker Techhype",
    //Footer
    footerHeading: "Lenker",
    footerLink1: "Kom i Gang",
    footerLink2: "Hvordan Det Fungerer",
    footerLink3: "Anmeldelser",
    footerLink4: "Kontakt Oss",
    footerLink5: "Logg inn",
    footerInfo:
      "Kontaktløs visittkort som bruker NFC-teknologi for å forenkle nettverking og deling av kontaktinformasjon.",
    copyRights: "Copyright ©Techhype 2023. Alle rettigheter reservert.",
    footerTermsHeading: "Vilkår og Personvern",
    footerTerms: "Vilkår og betingelser",
    footerPrivacy: "Personvernerklæring",
    footerFaq: "Ofte stilte spørsmål",
    //Contact Page
    contactHeading: "Kontakt Oss",
    contactSubHeading:
      "Har du et spørsmål eller trenger hjelp med en bestilling? Fyll bare ut skjemaet nedenfor.",
    selectLabel: "Trenger hjelp med..",
    selectOption1: "Generell henvendelse",
    selectOption2: "Min bestilling",
    selectOption3: "Teknisk Hjelp",
    nameLabel: "Navn",
    emailLabel: "E-post",
    phoneLabel: "Telefon",
    phonePlaceholder: "Valgfritt",
    messageLabel: "Melding",
    messagePlaceholder: "Skriv meldingen din her...",
    contactButton: "Send",
    //Shop Page
    shopHeading: "Velg Ditt Kort",
    productButton: "Velg",
    //Login Page
    loginHeading: "Logg Inn",
    userEmail: "E-post",
    password: "Passord",
    loginButton: "Logg Inn",
    forgotPassword: "Glemt Passord?",
    loginOr: "Eller",
    loginFacebook: "Logg inn med Facebook",
    loginGoogle: "Logg inn med Google",
    dontHaveAnAccount: "Ikke en konto?",
    registerHeading: "Registrer",
    registerName: "Navn",
    registerButton: "Registrer",
    alreadyHaveAnAccount: "Har du allerede en konto?",
    haveAccountLogin: "Logg inn",
    signUp: "Registrer deg",
    forgotPasswordHeader: "Glemt passord",
    resetPasswordButton: "Tilbakestill passord",
    backToLoginLink: "Tilbake til logg inn",
    //Reset password Page
    resetTitle: "Nytt Passord",
    resetButton: "Oppdater",
    //Cart Page
    cartHeading: "Handlekurv",
    cartEmpty: "Du har ingen varer i Handlekurven",
    cartTotal: "Totalt",
    cartRemove: "Fjern",
    shipping: "Frakt",
    checkout: "Gå Til Kasse",
    shippingInfo: "Fri frakt for ordre over 2000 Kr",
    cartTip: "Opprett din profil og design kortet ditt etter Betaling.",
    goToShopButton: "Kjøp kort",
    //BreadCrumbs
    home: "Hjem",
    shop: "Kom i Gang",
    //Product Details
    quantity: "Antall",
    addToCart: "Legg i Handlekurv",
    detailsAccordionHeader: "Detaljer",
    details1:
      "Techhype tar det beskjedne visittkortet rett inn i det 21. århundret med fullt integrert NFC-teknologi.",
    details2:
      "Våre visittkort er den perfekte måten å kommunisere med kunder og forretningsforbindelser - og gir deg fullstendig fleksibilitet innen markedsføring og nettverksbygging. Nå er du ikke lenger begrenset til bare å dele kontaktinformasjonen din. Med tilpassede handlinger kan du umiddelbart overføre informasjon eller utløse hvilken som helst handling på en smarttelefon.",
    details3:
      "Last opp en logo eller et bilde som trykkes direkte på kortet ditt.",
    warrantyAccordionHeader: "Garanti",
    warrantyText:
      "1 år. Gjelder kun hvis kortet er defekt. Tapt eller stjålet kort dekkes ikke av garantien.",
    FaqAccordionHeader: "Ofte stilte spørsmål",
    faqQuestion1: "Kan jeg ha flere profiler på ett kort?",
    faqAnswer1:
      "Ja, du kan ha opptil 3 profiler på ett kort. Kun én profil kan være aktiv om gangen. Du kan administrere profilene og deres aktive tilstand fra din konto.",
    faqQuestion2: "Fungerer kortet på alle smarttelefoner?",
    faqAnswer2:
      "Techhype Digitalt Visittkort fungerer på alle smarttelefoner som har NFC. De fleste nyere smarttelefoner har NFC-teknologi.",
    faqQuestion3: "Hva skal jeg gjøre hvis jeg mister kortet mitt?",
    faqAnswer3:
      "Hvis du mister kortet ditt, kan du enkelt gå til kontoen din og blokkere det for å sikre at det ikke blir misbrukt.",
      outOfStock: "Utsolgt",
    //Added to cart modal
    addedToCart: "Lagt i Handlekurv!",
    cartTotal: "Totalt",
    closeModalButton: "Lukk",
    GoToCartModalButton: "Til Handlekurv",
    //Checkout
    checkoutHeading: "Kasse",
    hideOrderSummary: "Skjul din Bestilling",
    showOrderSummary: "Vis din Bestilling",
    contactInfoShort: "Kontakt",
    contactInfoLong: "Kontakt Informasjon",
    checkoutHaveAccount: "Har du konto?",
    checkoutLogin: "Logg inn",
    checkoutEmail: "E-post",
    checkoutEmailPlaceholder: "Din@epost.no",
    checkoutPhonePlaceholder: "Valgfritt",
    checkoutPhone: "Telefon",
    shippingAddress: "Leveringsadresse",
    checkoutName: "Navn",
    checkoutCompany: "Firma",
    checkoutStreet: "Gateadresse",
    checkoutPostal: "Postnummer",
    checkoutCity: "By",
    checkoutReturnToCart: "Til Handlekurv",
    paymentButtonShort: "Betaling",
    paymentButtonLong: "Fortsett til Betaling",
    discountCode: "Rabatt Kode",
    DiscountButton: "Bruk",
    checkoutShipping: "Frakt",
    checkoutTotal: "Totalt",
    checkoutOrderSummary: "Din Bestilling",
    //Country Input
    countryInputLabel: "Land",
    countryInputPlaceholder: "Velg Land",
    //Phone Input
    phoneInputLabel: "Telefon",
    phoneInputError: "Telefon Nummer er for langt",
    //Payment
    paymentHeading: "Betaling",
    paymentReturnToCheckout: "Til Kasse",
    paymentButton: "Betal Nå",
    changeInfo: "Endre",
    paymentContact: "Kontakt",
    paymentShipTo: "Lever til",
    billingAddressHeader: "Faktureringsadresse",
    billingAddressSubheader:
      "Velg adressen som samsvarer med kortet ditt eller betalingsmetoden din.",
    billingOption1: "Samme som leveringsadresse",
    billingOption2: "Bruk en annen adresse",
    shippingMethodHeader: "Leveringsmetode",
    shippingOption1: "Standard (1-5 virkedager)",
    shippingOption2: "Hjemlevering (1-3 virkedager)",
    paymentHeader: "Betaling",
    paymentSubheader: "Alle transaksjoner er sikre og krypterte.",
    paymentOption1: "Kredittkort",
    paymentOption2: "Vipps",
    paymentCardNumberLabel: "Kort Nummer",
    paymentNameOnCardLabel: "Navn på kortet",
    paymentExpiryDateLabelLong: "Utløpsdato (MM / ÅÅ)",
    paymentExpiryDateLabelShort: "Utløpsdato (MM / ÅÅ)",
    paymentCVCCodeLabel: "CVC",
    //Confirmation Page
    confirmationPageTitle: "Din Bestilling er bekreftet!",
    orderNumber: "Ordre #",
    orderDetails: "Ordredetaljer",
    contactInformationHeader: "Kontaktinformasjon",
    paymentMethodHeader: "Betalingsmetode",
    paymentMethodCard: "Kort ender med",
    shippingAddressHeader: "Leveringsadresse",
    billingAddressHeader: "Faktureringsadresse",
    shippingMethodHeader: "Leveringsmetode",
    confirmationByEmail:
      "Du vil motta en bekreftelses-e-post med din ordre innen kort tid",
    needHelp: "Trenger du hjelp?",
    confirmationPageContactUs: "Kontakt oss",
    confirmationCreateProfileButton: "Opprett din profil",
    confirmationTooltip:
      "Opprett profilen din nå og begynn å designe visittkortet ditt!",
  },
};
